"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentField = void 0;
var StudentField;
(function (StudentField) {
    StudentField["IDENTITY_ID"] = "identityId";
    StudentField["EMAIL"] = "email";
    StudentField["GOOGLE_HASHED_EMAIL"] = "google_hashed_email";
    StudentField["NAME"] = "name";
    StudentField["FIRST_NAME"] = "first_name";
    StudentField["LAST_NAME"] = "last_name";
    StudentField["GENDER"] = "gender";
    StudentField["BIRTH_DATE"] = "birth_date";
    StudentField["TELEPHONE"] = "telephone";
    StudentField["SECONDARY_EMAILS"] = "secondary_emails";
    StudentField["START_PERIOD_DATE"] = "start_period_date";
    StudentField["FUNDING_TYPE"] = "funding_type";
    StudentField["STUDY_LEVEL"] = "study_level";
    StudentField["PREFERRED_STUDY_LEVEL"] = "preferred_study_level";
    StudentField["RESIDENCE_COUNTRY_ID"] = "residence_country_id";
    StudentField["NATIONALITY_COUNTRY_ID"] = "nationality_country_id";
    StudentField["NATIONALITY_COUNTRY_ISO"] = "nationality_country_iso";
    StudentField["STUDY_COUNTRY_ID"] = "study_country_id";
    StudentField["REGISTRATION_IP"] = "registration_ip";
    StudentField["REGISTRATION_PORTAL_TYPE"] = "registration_portal_type";
    StudentField["WORK_EXPERIENCE"] = "work_experience";
    StudentField["PROFICIENCY_TYPE"] = "proficiency_type";
    StudentField["PROFICIENCY_TEST"] = "proficiency_test";
    StudentField["PROFICIENCY_SCORE"] = "proficiency_score";
    StudentField["IELTS"] = "ielts";
    StudentField["CAE"] = "cae";
    StudentField["FCE"] = "fce";
    StudentField["TOEFL_IBT"] = "toefl_ibt";
    StudentField["TOEFL_PBT"] = "toefl_pbt";
    StudentField["PTE"] = "pte";
    StudentField["OTE"] = "ote";
    StudentField["DUOLINGO"] = "duolingo";
    StudentField["SELF_ASSESSMENT_PROFICIENCY"] = "self_assessment_proficiency";
    StudentField["INITIAL_REGISTRATION_PLATFORM"] = "initial_registration_platform";
    StudentField["REFERRER"] = "referrer";
    StudentField["EMAILING_OTHER"] = "emailing_other";
    StudentField["EMAILING_FAVOURITES"] = "emailing_favourites";
    StudentField["EMAILING_SCHOLARSHIPS"] = "emailing_scholarships";
    StudentField["EMAILING_UPDATES"] = "emailing_updates";
    StudentField["LAST_LOGIN_UTC"] = "last_login_utc";
    StudentField["DATE_CREATED_UTC"] = "date_created_utc";
    StudentField["DATE_MODIFIED_UTC"] = "date_modified_utc";
    StudentField["DATE_DELETED_UTC"] = "date_deleted_utc";
    StudentField["LOGINS"] = "logins";
    StudentField["DISCIPLINES"] = "disciplines";
    StudentField["INTERESTS_COUNTRIES"] = "interests_countries";
    StudentField["INTERESTS_DISCIPLINES"] = "interests_disciplines";
    StudentField["EMAIL_UNSUBSCRIBE_TOKEN"] = "emailUnsubscribeToken";
    StudentField["GDPR_ACCEPTED"] = "gdpr_accepted";
    StudentField["ORIGIN_ORGANISATION_ID"] = "origin_organisation_id";
    StudentField["FLAGS"] = "flags";
    StudentField["GPA"] = "gpa";
    StudentField["LIVING_BUDGET"] = "living_budget";
    StudentField["TUITION_BUDGET"] = "tuition_budget";
    StudentField["ACCOMPLISHMENTS"] = "accomplishments";
    StudentField["CURRENCY"] = "currency";
    StudentField["AFFILIATE"] = "affiliate";
    StudentField["AFFILIATE_URL"] = "affiliate_url";
    StudentField["ATTENDANCE"] = "attendance";
    StudentField["TRAFFIC_SOURCE"] = "traffic_source";
    StudentField["TRAFFIC_SOURCE_URL"] = "traffic_source_url";
    StudentField["DISMISSED_ONBOARDING_QUESTIONNAIRE"] = "dismissed_onboarding_questionnaire";
    StudentField["STARTED_ONBOARDING_QUESTIONNAIRE"] = "started_onboarding_questionnaire";
    StudentField["UNIBUDDY_CHATS"] = "unibuddy_chats";
    StudentField["UNIBUDDY_YEAR_OF_ENTRY"] = "unibuddy_year_of_entry";
    StudentField["LAST_STATE_CHANGE_HASH"] = "last_state_change_hash";
    StudentField["JOURNEY_STATE"] = "journey_state";
    StudentField["LAST_ACCEPTED_PRIVACY_POLICY_UTC"] = "last_accepted_privacy_policy_utc";
    StudentField["SCHOLARSHIP_ACCEPTANCES"] = "scholarship_acceptances";
})(StudentField = exports.StudentField || (exports.StudentField = {}));
//# sourceMappingURL=student-field.js.map